import n2words from 'n2words';

export function generateAdjustedChoices(correctNumber) {
    const alternatives = new Set();
    alternatives.add(correctNumber.toString());

    while (alternatives.size < 4) {
        const randomVariant =
            correctNumber +
            Math.floor(Math.random() * 10) * (Math.random() > 0.5 ? 1 : -1);
        alternatives.add(randomVariant.toString());
    }

    return Array.from(alternatives);
}

export function convertWordToNumber(word) {
    // Cache pour éviter de recalculer les mêmes conversions
    if (!convertWordToNumber.cache) {
        convertWordToNumber.cache = new Map();
    }

    // Fonction de normalisation avancée pour gérer les variations françaises
    const normalizeWord = (text) => {
        return text.toLowerCase()
            .replace(/-/g, ' ')           // Enlever les tirets
            .replace(/\s+/g, ' ')         // Normaliser les espaces multiples
            .replace(/vingts/g, 'vingt')  // "vingts" → "vingt"
            .replace(/cents/g, 'cent')    // "cents" → "cent" 
            .trim();
    };

    const normalizedWord = normalizeWord(word);

    // Vérifier le cache d'abord
    if (convertWordToNumber.cache.has(normalizedWord)) {
        return convertWordToNumber.cache.get(normalizedWord);
    }

    // Recherche intelligente basée sur la longueur et les mots-clés
    let maxRange = 1000; // Par défaut, chercher jusqu'à 1000

    // Adapter la plage selon les mots-clés détectés
    if (normalizedWord.includes('mille')) {
        maxRange = 100000;
    }
    if (normalizedWord.includes('million')) {
        maxRange = 1000000;
    }

    // Recherche dans la plage déterminée
    for (let i = 0; i < maxRange; i++) {
        try {
            const numberWord = n2words(i, { lang: "fr" });
            // Normaliser aussi le résultat de n2words pour la comparaison
            const normalizedNumberWord = normalizeWord(numberWord);
            
            if (normalizedNumberWord === normalizedWord) {
                // Stocker dans le cache pour les prochaines fois
                convertWordToNumber.cache.set(normalizedWord, i);
                return i;
            }
        } catch (error) {
            // En cas d'erreur avec n2words, continuer
            continue;
        }
    }

    // Stocker null dans le cache pour éviter de refaire la recherche
    convertWordToNumber.cache.set(normalizedWord, null);
    return null; // Nombre non trouvé
} 